export const shareConstants = {
  TotalNoOfShareeAllowed: 50,
  TotalNoOfShareePerShare: 10,
  IsDifferentPermissionForShareeAllowed: true,
  EmailIdToMaskSenderAddress: 'service@paypal.com',
  NameToMaskSenderName: 'PayPal',
  COCCountries: [
    'CN',
    'RU',
    'MO',
    'HK',
    'IR',
    'CU',
    'KP',
    'VE',
    'C2',
    'CHN',
    'RUS',
    'VEN',
    'HKG',
    'PRK',
    'CUB',
    'IRN',
    'MAC',
  ],
  FilePermissions: {
    list: 0,
    read: 1,
    readWrite: 3,
    readWriteExecute: 7,
  },
  FilePermissionsName: {
    list: 'List only',
    read: 'Download',
    readWrite: 'Download and Upload',
    readWriteExecute: 'Download, Upload, and Overwrite',
  },
  FilePermissionToServer: {
    list: 'list',
    read: 'download',
    readWrite: 'upload',
    readWriteExecute: 'overwrite',
  },
  DefaultPermissions: {
    permission: 'download',
    enableNotifications: false,
    enableOwnerNotifications: true,
    showCollaborators: false,
    enableEmailMask: false,
  },
  SharePermissionsFolder: {
    options: [
      'Download',
      'Download and Upload',
      'Download, Upload, and Overwrite',
      'List only',
    ],
    notification: {
      enableOwnerNotifications: 'Send notifications to me',
      enableNotifications: 'Send notifications for shared members',
      enableEmailMask: 'Mask Email Id while sharing with external users',
      /* temporarily hide options
        showCollaborators: 'Allow users to see with whom the folder is shared'
      */
    },
  },
  SharePermissionsFiles: {
    options: ['Download'],
    notification: {
      enableNotifications: 'Enable notifications for newly added users',
      enableEmailMask: 'Mask Email Id while sharing with external users',
    },
  },
  FilePermissionFromServer: {
    list: 'list',
    download: 'read',
    upload: 'readWrite',
    overwrite: 'readWriteExecute',
  },
  NeededShareeDetails: [
    'enableNotifications',
    'enableOwnerNotifications',
    'permission',
    'sharedBy',
    'showCollaborators',
  ],
  Notifications: {
    enableOwnerNotifications: 'Send notifications to me',
    enableNotifications: 'Send notifications for shared members',
    enableNotificationsFile: 'Enable notifications for newly added users',
    showCollaborators: 'Allow users to see with whom the folder is shared',
    enableEmailMask: 'Mask Email Id while sharing with external users',
  },
  localizeIdForPermissions: {
    list: 'share.permission.listOnly',
    read: 'share.permission.download',
    readWrite: 'share.permission.upload',
    readWriteExecute: 'share.permission.overwrite',
    enableNotifications: 'share.send.notification.to.shared.users',
    enableNotificationsFile: 'share.send.notification.for.new.users',
    enableOwnerNotifications: 'share.send.notification.to.me',
    showCollaborators: 'share.show.collaborators',
    enableEmailMask: 'share.show.email.mask',
  },
  NoAccessForExternalUserShare: 'share.no.role.for.external.share',
  NoAccessForExternalCOCUserShare: 'share.no.role.for.coc.external.share',
  InvalidEmailAlert: 'share.valid.email.alert',
  MailIdExistAlert: 'share.mail.exist.alert',
  ShareFileToSelfAlert: 'share.file.to.self',
  ShareFolderToSelfAlert: 'share.folder.to.self',
  NoAccessForExternalUserShareQA: 'share.no.external.share.alert',
  ShareWithDifferentPermissionAlert: 'share.same.permission.alert',
  CustomMessageNotAllowedAlert: 'share.message.permisison.alert',
  ValidateEmailIdAlert: 'share.validate.email.id.alert',
  UpdateFileShareSuccess: 'share.file.update.success',
  UpdateFolderShareSuccess: 'share.folder.update.success',
  UnShareFileSuccess: 'share.file.unshare.success',
  UnShareFolderSuccess: 'share.folder.unshare.success',
  ShareFileSuccess: 'share.file.share.success',
  ShareFolderSuccess: 'share.folder.share.success',
}
